import { SparklesIcon } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { tieneTasacionEnCurso, type EstadoInforme } from "@/lib/informes";

interface BotonDeGeneracionProps {
  informeId: number;
  estado: EstadoInforme;
}

/**
 * La puerta del expediente a la generación del informe con IA.
 *
 * Aparece desde la aceptación de la cotización, igual que las pestañas
 * técnicas: antes de eso el informe es un presupuesto y no hay nada que
 * generar. Usa el mismo predicado (`tieneTasacionEnCurso`) que ellas, no una
 * lista de estados propia.
 */
export function BotonDeGeneracion({ informeId, estado }: BotonDeGeneracionProps) {
  if (!tieneTasacionEnCurso(estado)) return null;

  return (
    <Button asChild variant="soft">
      <Link to={`/informes/${informeId}/generacion`}>
        <SparklesIcon aria-hidden className="size-4" />
        Generación del informe
      </Link>
    </Button>
  );
}
